export const PRODUCT_ADDED = 'PRODUCT_ADDED'
export const PRODUCT_REMOVED = 'PRODUCT_REMOVED'
export const ORDER_SUBMITTED = 'ORDER_SUBMITTED'
export const ALREADY_ORDERED = 'ALREADY_ORDERED'
export const RETRIVE_ORDERS = 'RETRIVE_ORDERS'
export const CLEAR_CART = 'CLEAR_CART'
export const ORDER_SUBMIT_FAILED = 'ORDER_SUBMIT_FAILED'
export const QUANTITY_INCREASE = 'QUANTITY_INCREASE'
export const QUANTITY_DECREASE = 'QUANTITY_DECREASE '
export const FILTER_PRODUCT = 'FILTER_PRODUCT'
export const SEARCH_FILTER = 'SEARCH_FILTER'
export const MAIN_IMAGE_DISPLAY = 'MAIN_IMAGE_DISPLAY'
